import { render, staticRenderFns } from "./LayoutHeader.vue?vue&type=template&id=115b6b12&scoped=true"
import script from "./LayoutHeader.vue?vue&type=script&lang=js"
export * from "./LayoutHeader.vue?vue&type=script&lang=js"
import style0 from "./LayoutHeader.vue?vue&type=style&index=0&id=115b6b12&prod&scoped=true&lang=less"
import style1 from "./LayoutHeader.vue?vue&type=style&index=1&id=115b6b12&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115b6b12",
  null
  
)

export default component.exports